import RulesUser from "./rules-user.page";

export default RulesUser;
